
import { Editable, IconButton, Text, Field, Box, Icon } from "@chakra-ui/react";
import useThemeColors from "../../../../hooks/useThemeColors";
import useIcons from "../../../../hooks/useIcons";

interface Props {
  handleSubmit: (property: string, value: string) => void;
  label: string;
  defaultValue: string | undefined;
  property: string;
  placeHolder?: string;
  body?: string;
}

export default function TextSetting({
  handleSubmit,
  label,
  property,
  defaultValue,
  placeHolder,
  body,
}: Props) {
  const colors = useThemeColors();
  const icons = useIcons();
  return (
    <Box bg={colors.background.subtle} p={3} borderRadius={"lg"} borderWidth={1}>
      <Field.Root>
        <Field.Label fontSize={"xs"} w={"100%"} textAlign={"left"}>
          {label}{" "}
        </Field.Label>
        <Text opacity={"0.5"} fontSize={"xs"}>
          {body || ""}
        </Text>
        <Editable.Root
          defaultValue={defaultValue || ""}
          onValueCommit={(details) => handleSubmit(property, details.value)}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          placeholder={placeHolder || ""}
        >
          <Editable.Preview fontWeight={"bold"} />
          <Editable.Input />
          <Editable.Control>
            <Editable.EditTrigger asChild>
              <IconButton aria-label="Edit" size="sm" variant="ghost">
                <Icon as={icons.utility.edit} />
              </IconButton>
            </Editable.EditTrigger>
            <Editable.CancelTrigger asChild>
              <IconButton aria-label="Cancel" size="sm" variant="outline">
                <Icon as={icons.utility.cancel} size="lg"/>
              </IconButton>
            </Editable.CancelTrigger>
            <Editable.SubmitTrigger asChild>
              <IconButton aria-label="Save" size="sm" variant="outline">
                <Icon as={icons.utility.check} size="lg"/>
              </IconButton>
            </Editable.SubmitTrigger>
          </Editable.Control>
        </Editable.Root>
      </Field.Root>
    </Box>
  );
}
